import React from 'react';
import PropTypes from 'prop-types';
import DataGrid from '../data-grid/'
import { Link, useHistory } from "react-router-dom";
import './feature-grid.scss';

export const FeatureGrid = ({features, hasMore, isLoading, length, onNext}) => {
	let history = useHistory();
	const FeatureTitleCell = ({value, row}) => {
		return <Link to={`/features/${row.values.featureId}`} key={`feature_title_${row.values.featureId}`} className={`grid-action grid-action-${row.values.featureId}`}>{value}</Link>
	}

	function handleRowClick (row) {
		history.push(`/features/${row.values.featureId}`);
	}

	const columnData = [
		{
			Header: 'Feature ID',
			accessor: 'id',
			id: 'featureId'
		},
		{
      Header: 'Feature Title',
			Cell: FeatureTitleCell,
      accessor: 'name'
    },
		{
      Header: 'Type',
			Cell: FeatureTitleCell,
      accessor: 'type'
    },
    {
      Header: 'Publish Date',
      accessor: 'publishDate'
    }
  ];

	return (
		<div className="feature-grid">
			<div className="col-layout label-with-actions grid-header">
				<div className="grid-title"><h1>Features</h1></div>
				<div className="actions grid-actions">
					<Link to="/add-feature/" className="btn primary">Add New Feature</Link>
				</div>
			</div>
			<div className="grid-body">
				<DataGrid
					data={features || []}
					columnData={columnData}
					hasMore={hasMore}
					hiddenColumns={['featureId']}
					isLoading={isLoading}
					length={length}
					onNext={onNext}
					onRowClick={handleRowClick}
				/>
			</div>
		</div>
	);
}

FeatureGrid.propTypes = {
	features: PropTypes.array,
	isLoading: PropTypes.bool
};

export default FeatureGrid;
